module.exports = __webpack_public_path__ + "static/media/footerImg1.36afc1b8.png";